module.exports = __webpack_public_path__ + "img/404Bizz.4af19354.svg";